// extracted by mini-css-extract-plugin
export var closeButton = "_mg-1";
export var closeX = "_mg-3";
export var container = "_mg-0";
export var image = "_mg-2";